import { render, staticRenderFns } from "./PainelPlans.vue?vue&type=template&id=4e91adde&scoped=true&"
import script from "./PainelPlans.vue?vue&type=script&lang=js&"
export * from "./PainelPlans.vue?vue&type=script&lang=js&"
import style0 from "./PainelPlans.vue?vue&type=style&index=0&id=4e91adde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e91adde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VIcon,VRow,VSkeletonLoader,VSwitch})
